import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavHomeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.48 10.93L13.3 0.750022C12.58 0.030022 11.41 0.030022 10.69 0.750022L0.51999 10.93C0.22999 11.22 0.22999 11.7 0.51999 11.99C0.75999 12.23 1.10999 12.26 1.39999 12.11V21.86C1.39999 22.88 2.22999 23.7 3.23999 23.7H20.76C21.78 23.7 22.61 22.87 22.61 21.86V12.11C22.72 12.17 22.83 12.21 22.95 12.21C23.14 12.21 23.33 12.14 23.48 11.99C23.77 11.7 23.77 11.22 23.48 10.93ZM14.66 22.21H9.33999V14.82H14.66V22.21ZM20.76 22.21H15.91V14.2C15.91 13.86 15.63 13.58 15.29 13.58H8.71999C8.36999 13.58 8.09999 13.86 8.09999 14.2V22.21H3.23999C3.04999 22.21 2.89999 22.06 2.89999 21.87V10.68L11.76 1.81002C11.89 1.68002 12.11 1.68002 12.25 1.81002L21.11 10.67V21.86C21.11 22.05 20.95 22.2 20.76 22.2V22.21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavHomeIcon.displayName = 'NavHomeIcon';
